import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PartnerDealCommitteeViewResponse } from '@interfaces/partners/responses/partner-deal-committee.response';
import { SharedModule } from '@src/app/shared/shared.module';
import { DealTab } from '@app/features/dashboard/commercial/pages/deal-detail/deal-tabs';
import {
  isRoundOpen,
  joinNames,
  pendingVoterNames,
} from '@app/features/dashboard/commercial/pages/deal-detail/components/deal-committee-panel/deal-committee-presenter';

/**
 * Lateral da etapa Comitê na tela do deal (card 3789): prazo para votar, regras do comitê e atalhos
 * para o material que os sócios leem antes de votar. Lê o comitê que o `app-deal-committee-panel`
 * carregou (pelo `viewChange`), sem nova consulta.
 *
 * O cartão escuro de fase não mora aqui: é o cartão "próximo passo" da tela, alimentado pelo
 * `resolveCommitteeNextStep`, para a lateral continuar tendo um único "e agora?".
 */
@Component({
  selector: 'app-deal-committee-aside',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './deal-committee-aside.component.html',
  styleUrl: './deal-committee-aside.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealCommitteeAsideComponent {
  /** Comitê carregado pelo painel. */
  readonly view = input<PartnerDealCommitteeViewResponse | null>(null);

  /** Atalho do material: abre uma aba da tela do deal. */
  readonly openTab = output<DealTab>();

  /** Rodada em votação, quando há. */
  protected readonly openRound = computed(() => {
    const current = this.view()?.current ?? null;
    return isRoundOpen(current) ? current : null;
  });

  /** Votos iguais que decidem: o da rodada, ou o da configuração quando não há rodada. */
  protected readonly majority = computed(() => {
    const view = this.view();
    if (view?.current) return view.current.majority;
    const count = view?.configuredVoterCount ?? 3;
    return Math.floor(count / 2) + 1;
  });

  /** "Guilherme Araldi e Rafael Buzin": quem ainda não deu voto final. */
  protected readonly pendingNames = computed(() => {
    const round = this.openRound();
    return round ? joinNames(pendingVoterNames(round)) : '';
  });
}
